module.exports = require('../_components/@alicd/next-pagination/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/pagination/index.js
// module id = 702
// module chunks = 0